<template>
    <sys-teacher-hub-modal
        :show="show"
        @update:show="$emit('update:show', $event)"
        :title="title"
        icon="mdi-clock-outline"
    >
        <v-card-text class="pa-4">
            <sys-teacher-confirmed-times
                :teacher="teacher"
                :work-time="workTime"
                :token="token"
            />
        </v-card-text>
    </sys-teacher-hub-modal>
</template>

<script>
export default {
    name: 'SysTeacherMyScheduleHub',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        teacher: {
            type: Object,
            required: true
        },
        workTime: {
            type: Object,
            required: true
        },
        token: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: 'Meus Horários'
        }
    }
}
</script>
